<script setup lang="ts">
const page = usePage().value;
const { isMobile } = useIsMobile();
</script>

<template>
  <section class="map-profile tmb-profile">
    <h3>Alta Via 1 Profile Map</h3>
    <div v-html="page?.mapProfileText"></div>
    <!-- Mobile: Zoomable image -->
    <div v-if="isMobile && page?.mapProfile" class="mobile-zoomable-image">
      <ElementMediumZoom
        :src="page?.mapProfile?.url"
        :alt="page?.mapProfile?.alt"
        class="map-profile-image"
        loading="lazy"
        :options="{
          background: 'rgba(0, 0, 0, 0.8)',
          margin: 20,
          scrollOffset: 0,
        }"
      />
    </div>

    <!-- Desktop: Regular NuxtPicture -->
    <NuxtPicture
      v-else-if="page?.mapProfile"
      format="webp"
      loading="lazy"
      :src="page?.mapProfile?.url"
      :width="page?.mapProfile?.width"
      :height="page?.mapProfile?.height"
      :alt="page?.mapProfile?.alt"
      sizes="sm:80vw md:50vw lg:1500px"
    />
  </section>
</template>
